import type { RefObject } from "react";

import { FormActionButtons } from "@a2z/ui";

type Props = {
  actionRef: RefObject<HTMLDivElement | null>;
  actionsVisible: boolean;
  shouldFloatActions: boolean;
  floatingVisible: boolean;
  formId: string;
  cancelLabel: string;
  saveLabel: string;
  loadingLabel: string;
  onCancel: () => void;
  isSaving: boolean;
  hideCancel: boolean;
};

export function ProductImagesFormActions({
  actionRef,
  actionsVisible,
  shouldFloatActions,
  floatingVisible,
  formId,
  cancelLabel,
  saveLabel,
  loadingLabel,
  onCancel,
  isSaving,
  hideCancel,
}: Props) {
  return (
    <>
      <div
        ref={actionRef}
        className={`overflow-hidden transition-all duration-300 ${
          actionsVisible
            ? "mt-4 max-h-24 translate-y-0 opacity-100"
            : "pointer-events-none mt-0 max-h-0 -translate-y-1 opacity-0"
        }`}
        aria-hidden={!actionsVisible}
      >
        <div className={actionsVisible ? "pb-1" : "pb-0"}>
          <FormActionButtons
            formId={formId}
            cancelLabel={cancelLabel}
            saveLabel={saveLabel}
            loadingLabel={loadingLabel}
            onCancel={onCancel}
            isSaving={isSaving}
            hideCancel={hideCancel}
          />
        </div>
      </div>
      {shouldFloatActions && actionsVisible ? (
        <div
          className={`fixed inset-x-0 bottom-[calc(4rem+env(safe-area-inset-bottom))] z-40 border-t border-[color:var(--border-light)] bg-[color:var(--surface)] px-4 py-3 shadow-[var(--shadow-sm)] transition-all duration-300 ease-out lg:bottom-0 ${
            floatingVisible
              ? "translate-y-0 opacity-100"
              : "translate-y-4 opacity-50"
          }`}
        >
          <div className="mx-auto max-w-[640px]">
            <FormActionButtons
              formId={formId}
              cancelLabel={cancelLabel}
              saveLabel={saveLabel}
              loadingLabel={loadingLabel}
              onCancel={onCancel}
              isSaving={isSaving}
              hideCancel={hideCancel}
              centered
            />
          </div>
        </div>
      ) : null}
    </>
  );
}
